import {
  Box,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
  useTheme,
} from "@mui/material";
import { Enumerations } from "../../config/Enumerations";
import moment from "moment";
import { Container } from "@mui/system";

export default function EntryDetails({ appEntry }) {
  const theme = useTheme();

  return (
    <Paper elevation={1} sx={{ padding: 2, mb: 1 }}>
      <div className="entry-details-title">
        <Typography
          variant="h6"
          style={{ color: theme.palette.secondary.main }}
        >
          Детали за барањето
        </Typography>
      </div>
      <Table size="small">
        <TableBody>
          <TableRow>
            <TableCell variant="head">Идентификатор</TableCell>
            <TableCell>{appEntry?.trackingNumber}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell variant="head">Архивски број (МТ)</TableCell>
            <TableCell>{appEntry?.archiveNumber}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell variant="head">Тип на барање</TableCell>
            <TableCell>
              {Enumerations.AppEntryTypeDisplay[appEntry?.type]}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell variant="head">Датум на поднесување</TableCell>
            <TableCell>
              {moment(appEntry?.dateSubmitted).format("DD.MM.YYYY HH:mm")}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell variant="head">Подносител</TableCell>
            <TableCell>
              {appEntry?.appEntryData?.applicantName}
              <br />
              {appEntry?.appEntryData?.applicantEmail}
              <br />
              {appEntry?.appEntryData?.applicantPhone}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell variant="head">Адреса</TableCell>
            <TableCell>
              {appEntry?.appEntryData?.applicantAddress}
              <br />
              {appEntry?.appEntryData?.applicantPlace}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Проектантско биро</TableCell>
            <TableCell>
              {appEntry?.appEntryData?.projectBureauName || "/"}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Проект</TableCell>
            <TableCell>{appEntry?.appEntryData?.projectTitle || "/"}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Локација</TableCell>
            <TableCell>
              {appEntry?.appEntryData?.locationDescription || "/"}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Технички број</TableCell>
            <TableCell>
              {appEntry?.appEntryData?.projectTechnicalNumber || "/"}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Предмет</TableCell>
            <TableCell>{appEntry?.appEntryData?.subject || "/"}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Paper>
  );
}
